import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form, Input, Button, message, Typography, Modal } from "antd";
import {
  KeyOutlined,
  EyeInvisibleOutlined,
  EyeTwoTone,
  UserOutlined,
  LockOutlined,
} from "@ant-design/icons";
import axios from "axios";
// import {checkLoginStatusInLocalStorage} from "./../../mylibs/list1";
// import {axiosi} from './../../../src/mylibs/list1'
// import useAxios from './../../CustomHooks/useAxios';
import useLogin from "./../../CustomHooks/useLogin";

import loginSlice from "./../../../src/redux/loginSlice";
const { Title, Paragraph, Text, Link, Link: AntLink } = Typography;

const MicrosoftIcon = () => (
  <svg width="18" height="18" viewBox="0 0 21 21" style={{ marginRight: 10, display: "inline-block", verticalAlign: "middle" }}>
    <rect x="1" y="1" width="9" height="9" fill="#f25022" />
    <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
    <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
    <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
  </svg>
);

export default function Login() {
  // const {axiosi}=useAxios();
  const [visibleForgotPassword, setVisibleForgotPassword] = React.useState(false);
  const [isForgotPasswordModalVisible, setIsForgotPasswordModalVisible] =
    React.useState(false);
  const [isSubmittingForgotPassword, setIsSubmittingForgotPassword] =
    React.useState(false);
  const usernameRef = React.useRef("");
  const [form] = Form.useForm();
  const [forgotPasswordForm] = Form.useForm(); // Form cho quên mật khẩu
  const { saveLoginStatus, removeLoginStatus } = useLogin();
  // const [showLocalLogin, setShowLocalLogin] = React.useState(() => {
  //   const method = localStorage.getItem("loginMethod");
  //   return method !== "microsoft";
  // });
  const [showLocalLogin, setShowLocalLogin] = React.useState(() => {
    const method = localStorage.getItem("loginMethod");
    if (method === null) {
      return "local";
    }
    return method;
  });

  const dispatch = useDispatch();





  React.useEffect(() => {
    const enableRefreshRegister = localStorage.getItem("enableRefreshRegister");
    if (enableRefreshRegister === null) {
      localStorage.setItem("enableRefreshRegister", false);
    }
  }, []);

  // Xử lý khi đóng modal quên mật khẩu
  const handleCancelForgotPasswordModal = () => {
    setIsForgotPasswordModalVisible(false);
    forgotPasswordForm.resetFields(); // Reset trường trong form khi hủy
  };
  const handleDoResetPassword = async (values) => {
    try {
      // Gọi API backend để yêu cầu reset password
      // URL này là ví dụ, bạn cần thay thế bằng URL API thực tế của mình
      // console.log(values);
      // return;
      const response = await axios.post(
        `${process.env.REACT_APP_DOMAIN}/users/doResetPassword`,
        { resetPasswordCode: values.resetPasswordCode }
      );

      console.log("[handleDoResetPassword]: response", response.data);

      // Giả sử backend trả về { success: true, message: "..." } khi thành công
      if (
        response.data.success ||
        response.status === 200 ||
        response.status === 201
      ) {
        message.success(
          response.data.message ||
          "Yêu cầu đặt lại mật khẩu đã được gửi. Vui lòng kiểm tra email của bạn."
        );
        setIsForgotPasswordModalVisible(false);
        forgotPasswordForm.resetFields();
      } else {
        message.error(
          response.data.message || "Không thể gửi yêu cầu. Vui lòng thử lại."
        );
      }
    } catch (error) {
      console.error("[ForgotPassword]: error", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        message.error(error.response.data.message);
      } else if (error.request) {
        message.error(
          "Không thể kết nối đến máy chủ để gửi yêu cầu. Vui lòng thử lại."
        );
      } else {
        message.error("Có lỗi xảy ra khi gửi yêu cầu đặt lại mật khẩu.");
      }
    } finally {
      setIsSubmittingForgotPassword(false);
    }
    setIsForgotPasswordModalVisible(false);
  };
  const handleResetPassword = async (e) => {
    e.preventDefault();
    // setIsForgotPasswordModalVisible(true);
    // return;

    const formValues = form.getFieldsValue();
    const userlogin = { username: formValues.username };

    // if (!username) {
    //   message.error("Vui lòng nhập tên đăng nhập");
    //   return;
    // }

    try {
      message.loading({ content: "Đang xử lý...", key: "resetPassword" });
      const response = await axios.post(
        `${process.env.REACT_APP_DOMAIN}/users/resetpassword`,
        userlogin,
        { withCredentials: true }
      );
      console.log("[ResetPassword]:done /users/resetpassword, kq=", response.data);
      const { code, message: msg } = response.data;
      switch (code) {
        case 200:
          message.success({
            content:
              "Yêu cầu đặt lại mật khẩu đã được gửi. Vui lòng kiểm tra email của bạn.",
            key: "resetPassword",
            duration: 5,
          });
          setIsForgotPasswordModalVisible(true);
          break;

        case 404:
          message.error({
            content: msg || "Không tìm thấy tài khoản",
            key: "resetPassword",
          });
          break;

        default:
          message.error({
            content: msg || "Đã xảy ra lỗi",
            key: "resetPassword",
          });
          break;
      }
    } catch (error) {
      // console.error("[ResetPassword] Error:", error);
      // console.error("error.response:", error.response.data);
      //  if (error.response) {
      //   message.error({
      //     content: error.response.data.message,
      //     key: "resetPassword",
      //   });
      //  }
      if (error.response?.data?.message) {
        message.error({
          content: error.response.data.message,
          key: "resetPassword",
        });
      } else if (error.request) {
        message.error({
          content: "request: Không thể kết nối đến máy chủ",
          key: "resetPassword",
        });
      } else {
        message.error({
          content: `Lỗi: ${error.message}`,
          key: "resetPassword",
        });
      }
    }
  };
  const onFinish = async (values) => {
    console.log("[Login]:done onFinish");
    const userlogin = { username: values.username, password: values.password };
    //const userlogin = { username: usernameRef.current.value, password: values.password };
    try {
      const kq = await axios.post(
        `${process.env.REACT_APP_DOMAIN}/users/login`,
        userlogin,
        { withCredentials: true }
      );
      console.log("[Login]:done /users/login");
      switch (kq.data.code) {
        case 200:
          break;
        case 401:
          message.error("Sai tên đăng nhập hoặc mật khẩu");
          removeLoginStatus();
          break;
        case 403:
          message.error("Tài khoản của bạn đã bị khóa");
          removeLoginStatus();
          break;
        default:
          message.error("Đăng nhập thất bại");
          removeLoginStatus();
          break;
      }
      if (kq.data.code === 200) {
        saveLoginStatus("1");
        localStorage.setItem("loginMethod", "local");
        console.log("[Login]:kq.data=", kq.data);
        dispatch(
          loginSlice.actions.setWebrtc({ webrtc: kq.data.agents[0].webrtc })
        );
        dispatch(loginSlice.actions.setUser({ user: kq.data }));
        // ✅ FIX: Dispatch setLogin để isLogined = true trong Redux ngay sau login thành công.
        // Thiếu dòng này khiến SIP Setup useEffect trong App.js không bao giờ kích hoạt
        // vì điều kiện `isLogined` luôn false cho đến khi user F5 trang.
        // dispatch(loginSlice.actions.setLogin({ isLogined: true }));
      }
      //  else {
      //   console.log("[Login]:khac 200");
      //   removeLoginStatus();
      //   message.error(kq.data.message || "Đăng nhập thất bại");
      // }
    } catch (error) {
      console.error("[Login]:error", error.message);
      console.error("[Login]:error.response.data", error.response.data);
      removeLoginStatus();

      // Hiển thị thông báo lỗi từ server nếu có
      if (error.response && error.response.data) {
        message.error(error.response.data.message || "Đăng nhập thất bại");
        const { attempts } = error.response.data;
        if (attempts >= 3) {
          setVisibleForgotPassword(true);
        }
      } else {
        message.error("Không thể kết nối đến máy chủ");
      }
    }

    console.log("done handlelogin");
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleSsoLogin = async () => {
    const res = await axios.get(`${process.env.REACT_APP_DOMAIN}/microsoft_graph_api/ms_login_url`);
    console.log("res", res);
    if (res.data.url) {
      window.location.href = res.data.url;
    }
  };
  const handleSsoLogin_Nestle = async () => {
    const res = await axios.get(`${process.env.REACT_APP_DOMAIN}/nestle_graph_api/ms_login_url`);
    console.log("res", res);
    if (res.data.url) {
      window.location.href = res.data.url;
    }
  };
  const i = Math.floor(Math.random() * 10) + 1;
  return (
    <div
      style={{
        backgroundImage: `url("./img/${i}.jpg")`,
        width: "100%",
        height: "100vh",
        margin: "0",
        position: "fixed",
        top: "0px",
        left: "0px",
        right: "0px",
        bottom: "0px",
        backgroundPosition: "center",
        backgroundSize: "cover",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontFamily: "system-ui, -apple-system, sans-serif",
      }}
    >
      <style>{`
        .custom-login-input {
          transition: all 0.3s ease !important;
        }
        .custom-login-input:hover, .custom-login-input:focus, .custom-login-input-focused {
          border-color: rgba(24, 144, 255, 0.6) !important;
          box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2) !important;
          background: rgba(255, 255, 255, 0.1) !important;
        }
        .custom-login-input input {
          color: white !important;
          background: transparent !important;
        }
        .custom-login-input input::placeholder {
          color: rgba(255, 255, 255, 0.45) !important;
        }
        .custom-login-input .ant-input-suffix .anticon {
          color: rgba(255, 255, 255, 0.45) !important;
        }
        .custom-login-input .ant-input-suffix .anticon:hover {
          color: rgba(255, 255, 255, 0.85) !important;
        }
        /* Autofill styles */
        .custom-login-input input:-webkit-autofill,
        .custom-login-input input:-webkit-autofill:hover, 
        .custom-login-input input:-webkit-autofill:focus {
          -webkit-text-fill-color: white !important;
          transition: background-color 5000s ease-in-out 0s;
        }
        .custom-login-microsoft-button {
          transition: all 0.3s ease !important;
        }
        .custom-login-microsoft-button:hover, .custom-login-microsoft-button:focus {
          background: rgba(255, 255, 255, 0.15) !important;
          border-color: rgba(255, 255, 255, 0.4) !important;
          color: white !important;
        }
      `}</style>

      {/* Dark gradient overlay for readability and contrast */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "linear-gradient(135deg, rgba(15, 23, 42, 0.5) 0%, rgba(15, 23, 42, 0.35) 100%)",
          zIndex: 1,
        }}
      />

      <div
        style={{
          position: "relative",
          zIndex: 2,
          padding: "40px 48px",
          width: "100%",
          maxWidth: "420px",
          color: "white",
          background: "rgba(255, 255, 255, 0.08)",
          backdropFilter: "blur(20px) saturate(160%)",
          WebkitBackdropFilter: "blur(20px) saturate(160%)",
          borderRadius: "24px",
          border: "1px solid rgba(255, 255, 255, 0.15)",
          boxShadow: "0 8px 32px 0 rgba(0, 0, 0, 0.37)",
        }}
      >
        <div style={{ marginBottom: "32px", textAlign: "center" }}>
          <Title level={2} style={{ color: "white", margin: "0 0 8px 0", fontWeight: "700", letterSpacing: "-0.5px" }}>
            Call Center
          </Title>
          <Text style={{ color: "rgba(255, 255, 255, 0.65)", fontSize: "14px" }}>
            Smart Call-Center Solution
          </Text>
        </div>

        <Form
          form={form}
          name="normal_login"
          className="login-form"
          layout="vertical"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          {showLocalLogin === "local" ? (
            <>
              <Form.Item
                name="username"
                label={<span style={{ color: "rgba(255, 255, 255, 0.85)", fontSize: "14px", fontWeight: "500" }}>Username</span>}
                rules={[
                  {
                    required: true,
                    message: "Please input your username!",
                  },
                ]}
              >
                <Input
                  prefix={<UserOutlined style={{ color: "rgba(255, 255, 255, 0.45)" }} />}
                  size="large"
                  placeholder="Username"
                  style={{
                    background: "rgba(255, 255, 255, 0.06)",
                    border: "1px solid rgba(255, 255, 255, 0.15)",
                    color: "white",
                    borderRadius: "8px",
                  }}
                  className="custom-login-input"
                />
              </Form.Item>

              <Form.Item
                name="password"
                label={<span style={{ color: "rgba(255, 255, 255, 0.85)", fontSize: "14px", fontWeight: "500" }}>Password</span>}
                rules={[
                  {
                    required: true,
                    message: "Please input your password!",
                  },
                ]}
              >
                <Input.Password
                  prefix={<LockOutlined style={{ color: "rgba(255, 255, 255, 0.45)" }} />}
                  size="large"
                  placeholder="Password"
                  style={{
                    background: "rgba(255, 255, 255, 0.06)",
                    border: "1px solid rgba(255, 255, 255, 0.15)",
                    color: "white",
                    borderRadius: "8px",
                  }}
                  className="custom-login-input"
                />
              </Form.Item>

              <Form.Item style={{ marginTop: "32px", marginBottom: "0px" }}>
                <Button
                  type="primary"
                  htmlType="submit"
                  size="large"
                  style={{
                    width: "100%",
                    borderRadius: "8px",
                    fontWeight: "600",
                    height: "45px",
                    border: "none",
                    background: "linear-gradient(135deg, #1890ff 0%, #0050b3 100%)",
                    boxShadow: "0 4px 12px rgba(24, 144, 255, 0.3)",
                  }}
                >
                  Login
                </Button>
              </Form.Item>

              <div style={{ display: "flex", alignItems: "center", margin: "20px 0" }}>
                <div style={{ flex: 1, height: "1px", background: "rgba(255, 255, 255, 0.15)" }} />
                <span style={{ padding: "0 16px", color: "rgba(255, 255, 255, 0.45)", fontSize: "13px" }}>or</span>
                <div style={{ flex: 1, height: "1px", background: "rgba(255, 255, 255, 0.15)" }} />
              </div>

              <Form.Item style={{ marginBottom: "0px" }}>
                <Button
                  type="default"
                  size="large"
                  onClick={handleSsoLogin}
                  style={{
                    width: "100%",
                    borderRadius: "8px",
                    fontWeight: "600",
                    height: "45px",
                    background: "rgba(255, 255, 255, 0.08)",
                    border: "1px solid rgba(255, 255, 255, 0.2)",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  }}
                  className="custom-login-microsoft-button"
                >
                  <MicrosoftIcon />
                  Sign in with Microsoft
                </Button>
              </Form.Item>
              <Form.Item style={{ marginBottom: "0px" }}>
                <Button
                  type="default"
                  size="large"
                  onClick={handleSsoLogin_Nestle}
                  style={{
                    width: "100%",
                    borderRadius: "8px",
                    fontWeight: "600",
                    height: "45px",
                    background: "rgba(255, 255, 255, 0.08)",
                    border: "1px solid rgba(255, 255, 255, 0.2)",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    marginTop: "16px",
                  }}
                  className="custom-login-microsoft-button"
                >
                  <MicrosoftIcon />
                  Sign in with Nestle Account
                </Button>
              </Form.Item>

              <Form.Item style={{ marginBottom: "0px", marginTop: "16px", textAlign: "center" }}>
                <AntLink
                  onClick={handleResetPassword}
                  style={{
                    color: "#ffd666",
                    display: visibleForgotPassword ? "inline-block" : "none",
                    fontWeight: "500",
                    textDecoration: "underline",
                  }}
                >
                  Reset Password
                </AntLink>
              </Form.Item>
            </>
          ) : showLocalLogin === "microsoft" ? (
            <>
              <Form.Item style={{ marginBottom: "0px" }}>
                <Button
                  type="primary"
                  size="large"
                  onClick={handleSsoLogin}
                  style={{
                    width: "100%",
                    borderRadius: "8px",
                    fontWeight: "600",
                    height: "45px",
                    border: "none",
                    background: "linear-gradient(135deg, #1890ff 0%, #0050b3 100%)",
                    boxShadow: "0 4px 12px rgba(24, 144, 255, 0.3)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <MicrosoftIcon />
                  Sign in with Microsoft
                </Button>
              </Form.Item>

              <div style={{ marginTop: "24px", textAlign: "center" }}>
                <AntLink
                  onClick={() => setShowLocalLogin("local")}
                  style={{
                    color: "rgba(255, 255, 255, 0.65)",
                    fontSize: "13px",
                    fontWeight: "500",
                    textDecoration: "underline",
                  }}
                >
                  Sign in with local account
                </AntLink>
              </div>
            </>
          ) : (
            <>
              <Form.Item style={{ marginBottom: "0px" }}>
                <Button
                  type="primary"
                  size="large"
                  onClick={handleSsoLogin_Nestle}
                  style={{
                    width: "100%",
                    borderRadius: "8px",
                    fontWeight: "600",
                    height: "45px",
                    border: "none",
                    background: "linear-gradient(135deg, #1890ff 0%, #0050b3 100%)",
                    boxShadow: "0 4px 12px rgba(24, 144, 255, 0.3)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <MicrosoftIcon />
                  Sign in with Nestle Account
                </Button>
              </Form.Item>

              <div style={{ marginTop: "24px", textAlign: "center" }}>
                <AntLink
                  onClick={() => setShowLocalLogin("local")}
                  style={{
                    color: "rgba(255, 255, 255, 0.65)",
                    fontSize: "13px",
                    fontWeight: "500",
                    textDecoration: "underline",
                  }}
                >
                  Sign in with local account
                </AntLink>
              </div>
            </>
          )}
        </Form>
      </div>

      <Modal
        title={
          <span style={{ fontSize: "18px", fontWeight: "600", color: "#1f1f1f" }}>
            Reset Password
          </span>
        }
        visible={isForgotPasswordModalVisible}
        onCancel={handleCancelForgotPasswordModal}
        footer={null}
        destroyOnClose
        width={400}
        centered
      >
        <Paragraph style={{ marginBottom: "20px", color: "#595959", lineHeight: "1.6" }}>
          The "Reset Password Code" has been sent to your email address. Please check your email and enter the code below to reset your password.
        </Paragraph>
        <Form
          form={forgotPasswordForm}
          name="forgot_password"
          initialValues={{ remember: true }}
          autoComplete="off"
          onFinish={handleDoResetPassword}
          layout="vertical"
        >
          <Form.Item
            name="resetPasswordCode"
            label={
              <span style={{ fontWeight: "500", color: "#262626" }}>Reset Password Code:</span>
            }
            rules={[
              {
                required: true,
                message: "Please input the reset password code!",
              },
            ]}
          >
            <Input
              size="large"
              placeholder="Enter validation code"
              style={{ borderRadius: "8px" }}
            />
          </Form.Item>
          <Form.Item style={{ textAlign: "right", marginTop: "24px", marginBottom: "0px" }}>
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              loading={isSubmittingForgotPassword}
              style={{
                borderRadius: "8px",
                fontWeight: "600",
                background: "linear-gradient(135deg, #1890ff 0%, #0050b3 100%)",
                border: "none",
                height: "40px",
                padding: "0 24px",
              }}
            >
              Reset Password
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}
